import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicy = () => createSelector(substate, (contextState) => contextState.policy);
